import React from "react";
import { useTranslation } from "react-i18next";
import "@google/model-viewer/dist/model-viewer";

import styled from "styled-components";
import {
    StyledARButton,
    StyledARIcon,
    StyledAnnotationWrapper,
    StyledAnnotation,
    StyledLink,
} from "../styles/Mainpage-styled";

import Button from "@material-ui/core/Button";
// import bg from "../assets/model_bg_png/ar_bg02.png";
import envBg from "../../../assets/model_bg_png/venice_sunset_1k.hdr";
import ARIcon from "../../../assets/ar_icon_button/ar_icon.svg";

const AnnotationWrapper = styled.div`
    ${StyledAnnotationWrapper};
`;

const ARButton = styled(({ arButtonState, ...otherProps }) => (
    <Button {...otherProps} />
))`
    ${StyledARButton};
`;

const VisitLink = styled.a`
    ${StyledLink};
`;

const ModelViewer = ({
    modelLazyImage,
    model,
    iosModel,
    modelViewerRef,
    handleActivateAR,
    arButtonState,
    annotationBg,
    textState,
    textLinkState,
    linkState,
    linkColorState,
}) => {
    const { t } = useTranslation();

    return (
        <model-viewer
            class="model"
            id="reveal"
            poster={modelLazyImage}
            loading="eager"
            ar
            ar-status
            camera-controls
            autoplay
            src={model}
            alt="AR Model"
            ios-src={iosModel}
            environment-image={envBg}
            ref={modelViewerRef}
        >
            <ARButton onClick={handleActivateAR} arButtonState={arButtonState}>
                <StyledARIcon src={ARIcon} alt="AR mode Icon" />
                {t("mainPage.button.viewArButton", "View in your space")}
            </ARButton>
            <button slot="ar-button"></button>
            <div
                class="slot"
                slot="hotspot-visor"
                data-position="0.0 0.27 0.0"
                data-normal="0.0 0.0 0.0"
            >
                <AnnotationWrapper annotationBg={annotationBg}>
                    <StyledAnnotation>{textState}</StyledAnnotation>
                    {linkState === "" || linkState === null ? (
                        <div></div>
                    ) : (
                        <VisitLink
                            linkColorState={linkColorState}
                            href={linkState}
                        >
                            {" "}
                            {/* {t("mainPage.link.visitShopLink", "Visit shop")} */}
                            {textLinkState}
                        </VisitLink>
                    )}
                </AnnotationWrapper>
            </div>
        </model-viewer>
    );
};

export default ModelViewer;
